import { Select } from '@shopify/polaris';

import { catalogsForLocation, ONLINE_PRICE_VALUE } from '#client/components/features/LabelPrinting/utils/productLabels';

/**
 * Which prices print on the label.
 *
 * Only the catalogs covering the selected location are offered, so an operator cannot
 * print a price their register will never ring. A location covered by exactly one catalog
 * has it preselected; where several apply nothing is preselected, because Shopify's own
 * resolution picks one without reporting which and that choice belongs to the operator.
 */
export function LabelCatalogSelect({ catalogs, locationGid, value, onChange, disabled }) {
    const applicable = catalogsForLocation(catalogs, locationGid);
    const mustChoose = applicable.length > 1 && !value;

    const options = [
        ...(mustChoose ? [{ label: 'Select a price catalog...', value: '', disabled: true }] : []),
        ...applicable.map((catalog) => ({ label: catalog.title, value: catalog.priceListId })),
        { label: 'Online (default price)', value: ONLINE_PRICE_VALUE },
    ];

    const helpText = !locationGid
        ? 'Select a location to see the catalogs that apply to it.'
        : applicable.length === 0
          ? 'No market catalog lists this location, so the online price prints.'
          : applicable.length > 1
            ? 'This location is in more than one market catalog. Pick the one to print.'
            : undefined;

    return <Select label="Price catalog" options={options} value={value} onChange={(next) => onChange(String(next))} disabled={disabled} helpText={helpText} error={mustChoose} />;
}
